export default {"src":"/_next/static/media/opd_insurance.8785241c.svg","height":71,"width":72,"blurWidth":0,"blurHeight":0};